// extracted by mini-css-extract-plugin
export default {"section":"Tracks_section__uPi+y","track":"Tracks_track__XyGAV","description":"Tracks_description__74SP6","icon":"Tracks_icon__B5WGM"};